import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6v7tnugur: FaireProductEntity = {
  token: "p_c6v7tnugur",
  type: "product",
  name: "Braves Beaded Earrings - Southern Statement - MLB Game Day",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/1fe060d44378b8668357434acc784450b18b0768db941e5bfd25379ddb5fbb85.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e266c6a6d527205cd6e6ddb77bb32d577dbfa3ccadb714166f3bd84d3872c55e.jpeg",
    "https://cdn.faire.com/fastly/516125d0785423b7e21eba9684f4fc8cd546c549994c1da08077721d314c7b30.jpeg",
    "https://cdn.faire.com/fastly/4e304456e10efa4f5c90d0e4d75a413a8575f5c89751053f9b060d592fba43a6.jpeg"
  ],
  priceDollars: 14,
  description: "Baseball “A” Braves Beaded Earrings - Brookhaven Baubles - Southern Statement Jewelry - Atlanta Braves Game Day Earrings, MLB Earrings\n\nAtlanta Braves “A” Baseball Earrings - Beaded Earrings - Southern Statement Jewelry - Beaded Statement Earrings - Fashion Earrings for Her - Game Day Earrings - Atlanta Braves Game Day Earrings - MLB Earrings - Baseball Mom Earrings\n\nLightweight acrylic seed bead earrings, ideal for Atlanta Braves fans.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:08.990Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
